export default {
  vgn: {
    name: 'Végétalien',
    emoji: '🌱',
  },
  vgt: {
    name: 'Végétarien',
    emoji: '🥬',
  },
  gf: {
    name: 'Sans gluten',
  },
  df: {
    name: 'Sans lactose',
  },
  hal: {
    name: 'Halal',
  },
  'h&s': {
    name: 'Épicé',
    emoji: '🌶',
  },
};
